import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import FallingLeaves from "@/components/site/FallingLeaves";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import HilfePage from "@/pages/HilfePage";
import TippsPage from "@/pages/TippsPage";
import ImpressumPage from "@/pages/ImpressumPage";

// Kümmert sich um sanftes Scrollen bei Seiten- und Anker-Wechsel.
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      // kurz warten, bis die Zielseite gerendert ist
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          if (lenis) lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      }, 120);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function Layout() {
  useLenis();
  return (
    <div className="App" data-testid="app-root">
      <div className="grain-overlay" />
      <FallingLeaves count={9} />
      <Navbar />
      <ScrollManager />
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hilfe" element={<HilfePage />} />
          <Route path="/tipps" element={<TippsPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
